import React from 'react';
import cx from 'classnames';
import { QRCodeSVG } from 'qrcode.react';
import { MinValue } from '../../../ui/texts/MinValue/index.js';
import styles from './index.module.scss.js';

const QrCode = ({
  img,
  minAmount,
  currency,
  v2,
  svgType = true,
  svgData = "",
  svgBgColor = "#ffffff",
  whiteBackground = false,
  className,
  style,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "div",
  {
    className: cx(styles.box, className, {
      [styles["white-background"]]: whiteBackground
    }),
    style: {
      ...style,
      "--qr-code-background": v2 ? "transparent" : whiteBackground ? "#fff" : "#001717",
      "--qr-code-padding": v2 ? "0" : "16px",
      "--qr-code-width": v2 ? "120px" : "152px",
      "--qr-code-height": v2 ? "120px" : "152px"
    },
    ...props
  },
  /* @__PURE__ */ React.createElement("div", { className: cx(styles["code-wrapper"]) }, !svgType && /* @__PURE__ */ React.createElement("img", { className: cx(styles.code), src: img, alt: "" }), svgType && /* @__PURE__ */ React.createElement(QRCodeSVG, { bgColor: svgBgColor, value: svgData })),
  currency && minAmount && /* @__PURE__ */ React.createElement(MinValue, { currency, minAmount })
);
QrCode.displayName = "QrCode";

export { QrCode };
//# sourceMappingURL=index.js.map
